import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Location, Action } from 'history';

export type BackNavigationCallback = (tx: {
  pathname: string;
  search: string;
  hash: string;
  state: unknown;
  action: Action;
}) => void;

export type ShouldInterceptCondition = (location: Location) => boolean;

interface UseInterceptBackNavigationProps {
  shouldIntercept: ShouldInterceptCondition;
  handleBack: BackNavigationCallback;
}

export const useInterceptBackNavigation = (
  props: UseInterceptBackNavigationProps,
): void => {
  const { handleBack, shouldIntercept = () => true } = props;
  const history = useHistory();

  useEffect(() => {
    const unblock = history.block((location: Location, action: Action) => {
      if (action === 'REPLACE' || !shouldIntercept(location)) {
        return undefined;
      }

      if (typeof handleBack !== 'function') {
        return false; // Prevent default back navigation
      }

      handleBack({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        state: location.state,
        action,
      });

      return false; // Prevent default back navigation
    });

    return unblock;
  }, [history, handleBack, shouldIntercept]);
};
